import { GetInitialData, InitialData } from 'owa-addins-apis';
import { OutlookEventDispId, triggerApiEvent } from 'owa-addins-events';
import {
    getTaskPaneRunningInstance,
    TaskPaneType,
    TaskPaneRunningInstance,
} from 'owa-addins-store';

export function sendItemNullEvent(): void {
    const taskPane: TaskPaneRunningInstance = getTaskPaneRunningInstance(TaskPaneType.Persistent);
    if (taskPane) {
        const newItem: InitialData = null;
        triggerApiEvent(OutlookEventDispId.ITEM_CHANGED_EVENT_DISPID, taskPane.controlId, newItem);
    }
}

export async function sendItemUpdatedEvent(hostItemIndex: string): Promise<void> {
    const taskPane: TaskPaneRunningInstance = getTaskPaneRunningInstance(TaskPaneType.Persistent);
    if (taskPane) {
        const newItem: InitialData = await GetInitialData(taskPane.controlId, hostItemIndex);
        triggerApiEvent(OutlookEventDispId.ITEM_CHANGED_EVENT_DISPID, taskPane.controlId, newItem);
    }
}
